import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { CoverImageFragmentDoc } from '../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HomeForms_MyLocationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomeForms_MyLocationsQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, locations: Array<{ __typename?: 'Location', id: number }> } } | null };

export type HomeForms_InstancesQueryVariables = Types.Exact<{
  input: Types.CompletionScheduleInstancesInput;
}>;


export type HomeForms_InstancesQuery = { __typename?: 'Query', CompletionScheduleInstances: { __typename?: 'CompletionScheduleInstances', objects: Array<{ __typename?: 'CompletionScheduleInstance', id: string, start: DateTimeUtc, end: DateTimeUtc, isOpen: boolean, status: Types.CompletionScheduleInstanceStatus, lateDeadline?: DateTimeUtc | null, completedBySkillInstance?: { __typename?: 'SkillInstance', id: string } | null, location: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, timezoneStr?: string | null } | null }, window: { __typename?: 'CompletionScheduleWindow', id: string, completionSchedule: { __typename?: 'CompletionSchedule', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, skill?: { __typename?: 'Skill', id: number } | null } } } }> } };

export type HomeForms_InstanceFragment = { __typename?: 'CompletionScheduleInstance', id: string, start: DateTimeUtc, end: DateTimeUtc, isOpen: boolean, status: Types.CompletionScheduleInstanceStatus, lateDeadline?: DateTimeUtc | null, completedBySkillInstance?: { __typename?: 'SkillInstance', id: string } | null, location: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', id: string, timezoneStr?: string | null } | null }, window: { __typename?: 'CompletionScheduleWindow', id: string, completionSchedule: { __typename?: 'CompletionSchedule', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, skill?: { __typename?: 'Skill', id: number } | null } } } };

export type HomeForms_FindChecklistDraftMutationVariables = Types.Exact<{
  input: Types.GetOrCreateTaskListInstanceDraftInput;
}>;


export type HomeForms_FindChecklistDraftMutation = { __typename?: 'Mutation', getOrCreateTaskListInstanceDraft: { __typename?: 'SkillInstanceMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, skillInstance?: { __typename?: 'SkillInstance', id: string, startedAt?: string | null } | null } };

export type HomeForms_FindAuditDraftMutationVariables = Types.Exact<{
  input: Types.GetOrCreateAuditInstanceDraftInput;
}>;


export type HomeForms_FindAuditDraftMutation = { __typename?: 'Mutation', getOrCreateAuditInstanceDraft: { __typename?: 'SkillInstanceMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, skillInstance?: { __typename?: 'SkillInstance', id: string, startedAt?: string | null } | null } };

export const HomeForms_InstanceFragmentDoc = gql`
    fragment HomeForms_Instance on CompletionScheduleInstance {
  id
  start
  end
  isOpen
  status
  lateDeadline
  completedBySkillInstance {
    id
  }
  location {
    id
    name
    address {
      id
      timezoneStr
    }
  }
  window {
    id
    completionSchedule {
      id
      libraryItem {
        id
        type
        name {
          uuid
          myTranslation
        }
        coverImage {
          ...CoverImage
        }
        skill {
          id
        }
      }
    }
  }
}
    ${CoverImageFragmentDoc}`;
export const HomeForms_MyLocationsDocument = gql`
    query HomeForms_MyLocations {
  Me {
    user {
      id
      locations {
        id
      }
    }
  }
}
    `;

/**
 * __useHomeForms_MyLocationsQuery__
 *
 * To run a query within a React component, call `useHomeForms_MyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeForms_MyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeForms_MyLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeForms_MyLocationsQuery(baseOptions?: Apollo.QueryHookOptions<HomeForms_MyLocationsQuery, HomeForms_MyLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeForms_MyLocationsQuery, HomeForms_MyLocationsQueryVariables>(HomeForms_MyLocationsDocument, options);
      }
export function useHomeForms_MyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeForms_MyLocationsQuery, HomeForms_MyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeForms_MyLocationsQuery, HomeForms_MyLocationsQueryVariables>(HomeForms_MyLocationsDocument, options);
        }
export type HomeForms_MyLocationsQueryHookResult = ReturnType<typeof useHomeForms_MyLocationsQuery>;
export type HomeForms_MyLocationsLazyQueryHookResult = ReturnType<typeof useHomeForms_MyLocationsLazyQuery>;
export type HomeForms_MyLocationsQueryResult = Apollo.QueryResult<HomeForms_MyLocationsQuery, HomeForms_MyLocationsQueryVariables>;
export const HomeForms_InstancesDocument = gql`
    query HomeForms_Instances($input: CompletionScheduleInstancesInput!) {
  CompletionScheduleInstances(input: $input) {
    objects {
      ...HomeForms_Instance
    }
  }
}
    ${HomeForms_InstanceFragmentDoc}`;

/**
 * __useHomeForms_InstancesQuery__
 *
 * To run a query within a React component, call `useHomeForms_InstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeForms_InstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeForms_InstancesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeForms_InstancesQuery(baseOptions: Apollo.QueryHookOptions<HomeForms_InstancesQuery, HomeForms_InstancesQueryVariables> & ({ variables: HomeForms_InstancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeForms_InstancesQuery, HomeForms_InstancesQueryVariables>(HomeForms_InstancesDocument, options);
      }
export function useHomeForms_InstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeForms_InstancesQuery, HomeForms_InstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeForms_InstancesQuery, HomeForms_InstancesQueryVariables>(HomeForms_InstancesDocument, options);
        }
export type HomeForms_InstancesQueryHookResult = ReturnType<typeof useHomeForms_InstancesQuery>;
export type HomeForms_InstancesLazyQueryHookResult = ReturnType<typeof useHomeForms_InstancesLazyQuery>;
export type HomeForms_InstancesQueryResult = Apollo.QueryResult<HomeForms_InstancesQuery, HomeForms_InstancesQueryVariables>;
export const HomeForms_FindChecklistDraftDocument = gql`
    mutation HomeForms_FindChecklistDraft($input: GetOrCreateTaskListInstanceDraftInput!) {
  getOrCreateTaskListInstanceDraft(input: $input) {
    success
    error {
      code
    }
    skillInstance {
      id
      startedAt
    }
  }
}
    `;
export type HomeForms_FindChecklistDraftMutationFn = Apollo.MutationFunction<HomeForms_FindChecklistDraftMutation, HomeForms_FindChecklistDraftMutationVariables>;

/**
 * __useHomeForms_FindChecklistDraftMutation__
 *
 * To run a mutation, you first call `useHomeForms_FindChecklistDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeForms_FindChecklistDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeFormsFindChecklistDraftMutation, { data, loading, error }] = useHomeForms_FindChecklistDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeForms_FindChecklistDraftMutation(baseOptions?: Apollo.MutationHookOptions<HomeForms_FindChecklistDraftMutation, HomeForms_FindChecklistDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HomeForms_FindChecklistDraftMutation, HomeForms_FindChecklistDraftMutationVariables>(HomeForms_FindChecklistDraftDocument, options);
      }
export type HomeForms_FindChecklistDraftMutationHookResult = ReturnType<typeof useHomeForms_FindChecklistDraftMutation>;
export type HomeForms_FindChecklistDraftMutationResult = Apollo.MutationResult<HomeForms_FindChecklistDraftMutation>;
export type HomeForms_FindChecklistDraftMutationOptions = Apollo.BaseMutationOptions<HomeForms_FindChecklistDraftMutation, HomeForms_FindChecklistDraftMutationVariables>;
export const HomeForms_FindAuditDraftDocument = gql`
    mutation HomeForms_FindAuditDraft($input: GetOrCreateAuditInstanceDraftInput!) {
  getOrCreateAuditInstanceDraft(input: $input) {
    success
    error {
      code
    }
    skillInstance {
      id
      startedAt
    }
  }
}
    `;
export type HomeForms_FindAuditDraftMutationFn = Apollo.MutationFunction<HomeForms_FindAuditDraftMutation, HomeForms_FindAuditDraftMutationVariables>;

/**
 * __useHomeForms_FindAuditDraftMutation__
 *
 * To run a mutation, you first call `useHomeForms_FindAuditDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeForms_FindAuditDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeFormsFindAuditDraftMutation, { data, loading, error }] = useHomeForms_FindAuditDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHomeForms_FindAuditDraftMutation(baseOptions?: Apollo.MutationHookOptions<HomeForms_FindAuditDraftMutation, HomeForms_FindAuditDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HomeForms_FindAuditDraftMutation, HomeForms_FindAuditDraftMutationVariables>(HomeForms_FindAuditDraftDocument, options);
      }
export type HomeForms_FindAuditDraftMutationHookResult = ReturnType<typeof useHomeForms_FindAuditDraftMutation>;
export type HomeForms_FindAuditDraftMutationResult = Apollo.MutationResult<HomeForms_FindAuditDraftMutation>;
export type HomeForms_FindAuditDraftMutationOptions = Apollo.BaseMutationOptions<HomeForms_FindAuditDraftMutation, HomeForms_FindAuditDraftMutationVariables>;